import { HttpInterceptor, HttpHandler, HttpEvent, HttpRequest, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { environment } from 'src/environments/environment';
import { SKIP_AUTH_INTERCEPTOR } from './skip-auth.context';
import { AppStateInterface } from 'src/app/appState.interface';
import { getApplySelectedCustomer } from 'src/app/core/store/selectors';
import { CustomerHierarchyService } from 'src/app/shared/customization/customers-tree/customer-hierarchy.service';
import { ONE_CUSTOMER_ENDPOINT } from 'src/app/core/config/config.constants';

@Injectable({
  providedIn: 'root'
})
export class HeadersInterceptor implements HttpInterceptor {

  constructor(
    private store: Store<AppStateInterface>,
    private customerHierarchy: CustomerHierarchyService
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Skip interceptor if context flag is set
    if (req.context.get(SKIP_AUTH_INTERCEPTOR)) {
      return next.handle(req);
    }

    // NON intercettare chiamate a Keycloak (per RuleEngine auth)
    if (req.url.includes(environment.ruleEngine?.keycloak?.authority || 'dev-iam.actiaitaliaserviceprovider.com')) {
      return next.handle(req);
    }

    // NON intercettare chiamate a RuleEngine API (ha già i suoi header)
    if (req.url.includes(environment.ruleEngine?.apiUrl || 'localhost:4000')) {
      return next.handle(req);
    }

    // NON intercettare chiamate UControl API (ha già i suoi header, gestiti da UcontrolAuthInterceptor)
    if (req.url.includes(environment.ucontrol?.apiUrl || 'uc-diaglight.dts1.actiafleet.com')) {
      return next.handle(req);
    }

    // NON intercettare chiamate al Keycloak di UControl (token endpoint, no header custom ammessi in CORS)
    if (req.url.includes(environment.ucontrol?.keycloak?.authority || 'iam.actiaitaliaserviceprovider.com')) {
      return next.handle(req);
    }

    const modifiedReq = req.clone({
      headers: req.headers
        .set('Api-Version', environment.apiVersion)
        .set('AF3-Client-Version', environment.clientVersion)
    });

    // NON intercettare la lookup "singolo customer" usata da CustomerHierarchyService per
    // risalire la gerarchia via backend: guard esplicito, indipendente dal fatto che oggi
    // baseApi e baseReports siano host diversi (vedi riga sotto).
    if (req.url.includes(ONE_CUSTOMER_ENDPOINT)) {
      return next.handle(modifiedReq);
    }

    if (!req.url.startsWith(environment.baseReports)) {
      return next.handle(modifiedReq);
    }

    return this.store.select(getApplySelectedCustomer).pipe(
      take(1),
      switchMap(applyCustomer => this.customerHierarchy.buildAncestorPath$(applyCustomer?.uid)),
      switchMap(path => {
        const finalReq = path
          ? modifiedReq.clone({ headers: modifiedReq.headers.set('x-customer-id', path) })
          : modifiedReq;
        return next.handle(finalReq);
      })
    );
  }
}
